/**
 * CTA Beneficials Section - Accordion functionality
 * Handles closing accordion items when clicking the close button
 */

window.ctaBeneficialsLoaded = true;

class CTABeneficials extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // Abort previous listeners if re-connected
    if (this._abortController) this._abortController.abort();
    this._abortController = new AbortController();

    // Add a slight delay to ensure DOM is fully ready
    setTimeout(() => {
      this.initializeCloseButtons();
      this.initializeOpenAnimation();
      this.lockRightHeight();
    }, 100);
  }

  disconnectedCallback() {
    if (this._abortController) {
      this._abortController.abort();
      this._abortController = null;
    }
  }

  initializeOpenAnimation() {
    const accordionItems = this.querySelectorAll('.cta-beneficials__item');
    
    const signal = this._abortController ? this._abortController.signal : undefined;

    accordionItems.forEach((item, index) => {
      const summary = item.querySelector('.cta-beneficials__item-header');
      
      if (summary) {
        summary.addEventListener('click', (e) => {
          e.preventDefault();

          if (item.classList.contains('is-closing')) return;

          if (item.hasAttribute('open')) {
            // Closing via summary click — use animated close
            item.classList.add('is-closing');
            setTimeout(() => {
              item.removeAttribute('open');
              item.classList.remove('is-closing');
            }, 600);
          } else {
            // Start closing any open item and open the new one simultaneously
            accordionItems.forEach((otherItem) => {
              if (otherItem !== item && otherItem.hasAttribute('open')) {
                otherItem.classList.add('is-closing');
                setTimeout(() => {
                  otherItem.removeAttribute('open');
                  otherItem.classList.remove('is-closing');
                }, 600);
              }
            });
            item.setAttribute('open', '');
          }
        }, { signal });
      }
    });
  }

  lockRightHeight() {
    const right = /** @type {HTMLElement|null} */ (this.querySelector('.cta-beneficials__right'));
    if (!right) return;
    const h = right.getBoundingClientRect().height;
    if (h > 0) right.style.minHeight = h + 'px';
  }

  initializeCloseButtons() {
    const closeButtons = this.querySelectorAll('.cta-beneficials__item-close');
    closeButtons.forEach((btn) => {
      if (!btn.getAttribute('aria-label') && !btn.textContent.trim()) {
        btn.setAttribute('aria-label', 'Close');
      }
    });
    const contentTitles = this.querySelectorAll('.cta-beneficials__item-text .cta-beneficials__item-title');
    const signal = this._abortController ? this._abortController.signal : undefined;
    
    // Function to close accordion with smooth animation
    const closeAccordion = (element, source) => {
      const detailsElement = element.closest('.cta-beneficials__item');
      
      if (detailsElement && detailsElement.hasAttribute('open')) {
        // Add closing class to trigger CSS animation
        detailsElement.classList.add('is-closing');
        
        // Wait for animation to complete before removing open attribute
        // Using 600ms to match the grid-template-rows transition duration
        setTimeout(() => {
          detailsElement.removeAttribute('open');
          detailsElement.classList.remove('is-closing');
        }, 600);
      }
    };
    
    // Add listeners to close buttons
    closeButtons.forEach((button, index) => {
      // Use capture phase to intercept before Replo
      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        
        closeAccordion(button, 'CLOSE BUTTON');
        
        return false;
      }, { capture: true, signal }); // Capture phase + abort signal
    });
    
    // Add listeners to content titles (when accordion is open)
    contentTitles.forEach((title, index) => {
      title.style.cursor = 'pointer';
      
      title.addEventListener('click', (event) => {
        // Only close if the accordion is open
        const detailsElement = title.closest('.cta-beneficials__item');
        if (detailsElement && detailsElement.hasAttribute('open')) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          
          closeAccordion(title, 'TITLE');
          
          return false;
        }
      }, { capture: true, signal }); // Capture phase + abort signal
    });
  }
}

customElements.define('cta-beneficials', CTABeneficials);

// Global click interceptor for Replo compatibility
document.addEventListener('click', function(e) {
  const closeBtn = e.target.closest('.cta-beneficials__item-close');
  if (closeBtn) {
    // Interceptor triggered
  }
}, true); // Capture phase - run before ANY other handlers
